import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';

import { Provider } from "react-redux"; // The Provider component is imported from the react-redux library. It is a higher-order component that provides the Redux store to the React application.
import {store} from "../src/redux/store.js"; // The store is imported from the store.js file
import  {persistor}  from "../src/redux/store.js";
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>{/*Then, we wrap our App component with the Provider function and pass the store as a prop. This makes the Redux store available to all the components inside the App */}
      <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>  
);
